import React from 'react';
import styled from 'styled-components';

interface ListProps {
  children: React.ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  theme: { [key: string]: any };
}

export default function List({ children }: ListProps) {
  return <ListItems>{children}</ListItems>;
}

const ListItems = styled.ul`
  list-style: none;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 12px;
`;
